import yousersjs from '@yola/yousersjs';

const sendVerificationEmail = () => yousersjs.requests.sendVerificationEmail();

export default sendVerificationEmail;
